import { Heading, type HeadingProps } from "@/components/ui/heading.tsx";
import { cn } from "cn";

const SECTION_TITLE_CLASSES = "text-xl/snug sm:text-xl/snug";

const PAGE_SIZE_CLASSES = "text-4xl leading-none font-normal sm:text-4xl";

export interface SectionTitleProps extends Omit<HeadingProps, "level"> {
    size?: "page";
}

export function SectionTitle({ className, size, ...rest }: SectionTitleProps) {
    return <Heading level={2} className={cn(size === "page" ? PAGE_SIZE_CLASSES : SECTION_TITLE_CLASSES, className)} {...rest} />;
}
